import { atom } from "recoil";

export const actionExceptionProfitId = atom({
  key: "actionExceptionProfitId",
  default: {},
});
